import { render, staticRenderFns } from "./TermCondition.vue?vue&type=template&id=2cfefc9e&scoped=true&"
import script from "./TermCondition.vue?vue&type=script&lang=js&"
export * from "./TermCondition.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/howto.scss?vue&type=style&index=0&id=2cfefc9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfefc9e",
  null
  
)

export default component.exports